import React, { useEffect, useState } from 'react'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import LeftThreeDot from '../../../assets/v2/JSX/LeftThreeDot'
import RightThreeDot from '../../../assets/v2/JSX/RightThreeDot'
import CompanySelect from '../../../components/v2/CompanySelect'
import { Container } from '../../../assets/styles/GlobalStyle'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import GreenTick from '../../../assets/v2/JSX/GreenTick'
import RedCross from '../../../assets/v2/JSX/RedCross'

import { useAppDispatch, useAppSelector } from '../../../store'
import { HealthState, setOffer, setPaymentScheduleArr } from '../../../store/healthSlice'
import Loader from '../../../components/Loader'
import GetBetterOffer from '../../../components/v2/GetBetterOffer'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import CustomLink from '../../../components/v2/CustomLink'
import MovingPrice from '../../../components/v2/MovingPrice'
import dayjs from 'dayjs'
import WarningMessage from '../../../components/v2/WarningMessage'
import BaseModal from '../../../components/v2/modals/BaseModal'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthOffer = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { filter, screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //
  const MainOffer = filter.offer

  // ###############
  const [scrollPosition, setScrollPosition] = useState(0)
  const handleScroll = () => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  // ###############
  const [selectedCoverageId, setSelectedCoverageId] = useState<number | undefined>(0)

  //fake data
  const fakeData = {
    translations: {
      ge: {
        stepName: 'შეთავაზება',
      },
      en: {
        stepName: 'offer',
      },
    },
    healthRisks: [
      {
        healthRisKId: 1,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/1l.jn16sohch-damatebiti-dafarva---Ambulatory.svg',
        riskName: 'Ambulatory',
        riskDescription:
          'ითვალისწინებს გადაუდებელი სამედიცინო მომსახურების გაწევას, რომელიც არ საჭიროებს სამედიცინო დაწესებულებაში დაყოვნებას 24 საათზე მეტი ხნით',
        translations: {
          en: {
            title: 'Ambulatory',
          },
          ge: {
            title: 'ამბულატორია',
          },
        },
      },
      {
        healthRisKId: 2,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/1q.mgp445d58o-damatebiti-dafarva---Stationary.svg',
        riskName: 'Stationary',
        riskDescription:
          'ითვალისწინებს გადაუდებელი სამედიცინო მომსახურების გაწევას, რომელიც საჭიროებს სამედიცინო დაწესებულებაში დაყოვნებას 24 საათით ან მეტი ხნით',
        translations: {
          en: {
            title: 'Stationary',
          },
          ge: {
            title: 'სტაციონარი',
          },
        },
      },
      {
        healthRisKId: 3,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/27.8bhj38acig-damatebiti-dafarva---Emergency.svg',
        riskName: 'Emergency',
        riskDescription:
          'ითვალისწინებს საქართველოს ტერიტორიაზე არსებული ნებისმიერი ლიცენზირებული სასწრაფო სამედიცინო დახმარების ბრიგადის მომსახურებას, შესაბამისი სამედიცინო ჩვენებით',
        translations: {
          en: {
            title: 'Emergency',
          },
          ge: {
            title: 'სასწრაფო',
          },
        },
      },
      {
        healthRisKId: 4,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/n.i1s0ptcov4-damatebiti-dafarva---Stomatology.svg',
        riskName: 'Stomatology',
        riskDescription:
          'ითვალისწინებს წვავე ტკივილის მოხსნის, ან/და კბილის ამოღებასთან დაკავშირებული მანიპუნაციების ჩატარებას, შესაბამისი სამედიცინო ჩვენები მიხედვით',
        translations: {
          en: {
            title: 'Stomatology',
          },
          ge: {
            title: 'სტომატოლოგია',
          },
        },
      },
      {
        healthRisKId: 5,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/g.lqrchqdd9g-damatebiti-dafarva---optamology.svg',
        riskName: 'Ophtamology',
        riskDescription: 'ითვალისწინებს, თვალის ტრავმული დაზიანების შემთხვევაში სამედიცინო მომსახურების გაწევას',
        translations: {
          en: {
            title: 'Ophtamology',
          },
          ge: {
            title: 'ოფთალმოლოგია',
          },
        },
      },
      {
        healthRisKId: 6,
        icon: 'https://d3cd9cyzr3ifxh.cloudfront.net/images/1t.uqkcd9m8ro-Mask-Group-461.png',
        riskName: 'other',
        riskDescription:
          'ვიწრო სპეციალისტის კონსულტაცია ითვალისწინებს: ქალბატონებისთვის - გინეკოლოგის ან მამოლოგის კონსულტაციას; მამაკაცებისთვის - უროლოგის ან კარდიოლოგის კონსულტაციას; ბავშვებისთვის - პედიატრის, ორთოპედის ან ოფთალმოლოგის კონსულტაციას',
        translations: {
          en: {
            title: 'Other',
          },
          ge: {
            title: 'სხვა',
          },
        },
      },
    ],
    covered: {
      irao: [
        {
          id: 1,
          body: 'პოლისი ძალაში შედის სადაზღვევო პრემიის პირვლადი შენატანის სრულად დაფარვის შემთხვევაში შეძენიდან 14 კალენდარული დღის შემდეგ.',
        },
        {
          id: 2,
          body: 'ჯანმრთელობის დაზღვევის დეტალურ პირობებს და კონკრეტულ დაავადებებთან დაკავშირებულ მნიშვნელოვან ინფორმაციას გაეცანით ხელშეკრულებაში',
        },
        { id: 3, body: 'ყურადღება გაამახვილეთ იმ სერვისებზე რომელზეც ვრცელდება მოცდის პერიოდი' },
        {
          id: 4,
          body: 'მოცდის პერიოდი - ის პერიოდი რომლის განმავლობაშიც კონკრეტული სამედიცინო მომსახურების ხარჯები დროებით არ ანაზღაურდება',
        },
        {
          id: 5,
          body: 'ექიმთან ვიზიტის დასაჯავშნად ან სატელეფონო კონსულტაციის მისაღებად დაუკავშირდით ირაოს ცხელ ხაზს ნომერზე: 0322 949 949',
        },
        {
          id: 6,
          body: 'ოჯახის ექიმი მოგისმენთ და უზრუნველყოფს საჭირო კვლევებისა და მიმართვების გამოწერას პროვაიდერ კლინიკებში წარსადგენად',
        },
        {
          id: 7,
          body: 'პროვაიდერ კლინიკაში მიმართვისას ადგილზე იხდით მხოლოდ პოლისით გათვალისწინებულ თქვენს წილ თანხას (ასეთის არსებობის შემთხვევაში)',
        },
        {
          id: 8,
          body: 'პირადი ექიმის მიერ დანიშნული მედიკამენტების შეძენა პროვაიდერ სააფთიაქო ქსელებში შეგიძლიათ თანადაფინანსებით, პოლისისა და პირადობის მოწმობის წარდგენის საფუძველზე',
        },
        {
          id: 9,
          body: 'აღნიშნული პოლისით გათვალისწინებულია პროფილაქტიკური კვლევების დაფინანსება წელიწადში ორჯერ,მათ შორის ერთი სისტემის ექოსკოპიაც',
        },
      ],
      ardi: [
        {
          id: 1,
          body: 'პოლისის ავტომატურად ძალაში შედის  რეგისტრაციიდან მესამე კალენდარულ დღეს',
        },
        {
          id: 2,
          body: 'ჯანმრთელობის დაზღვევის დეტალურ პირობებს და კონკრეტულ დაავადებებთან დაკავშირებულ მნიშვნელოვან ინფორმაციას გაეცანით ხელშეკრულებაში',
        },
        { id: 3, body: 'ყურადღება გაამახვილეთ იმ სერვისებზე რომელზეც ვრცელდება მოცდის პერიოდი' },
        {
          id: 4,
          body: 'მოცდის პერიოდი - ის პერიოდი რომლის განმავლობაშიც კონკრეტული სამედიცინო მომსახურების ხარჯები დროებით არ ანაზღაურდება',
        },
        {
          id: 5,
          body: 'ექიმთან ვიზიტის დასაჯავშნად ან სატელეფონო კონსულტაციის მისაღებად დაუკავშირდით არდის ცხელ ხაზს ნომერზე: 0322 10 10 10',
        },
        {
          id: 6,
          body: 'ოჯახის ექიმი მოგისმენთ და უზრუნველყოფს საჭირო კვლევებისა და მიმართვების გამოწერას პროვაიდერ კლინიკებში წარსადგენად',
        },
        {
          id: 7,
          body: 'პროვაიდერ კლინიკაში მიმართვისას ადგილზე იხდით მხოლოდ პოლისით გათვალისწინებულ თქვენს წილ თანხას (ასეთის არსებობის შემთხვევაში)',
        },
        {
          id: 8,
          body: 'პირადი ექიმის მიერ დანიშნული მედიკამენტების შეძენა პროვაიდერ სააფთიაქო ქსელებში შეგიძლიათ თანადაფინანსებით, პოლისისა და პირადობის მოწმობის წარდგენის საფუძველზე',
        },
      ],
      imediL: [
        {
          id: 2,
          body: 'ჯანმრთელობის დაზღვევის დეტალურ პირობებს და კონკრეტულ დაავადებებთან დაკავშირებულ მნიშვნელოვან ინფორმაციას გაეცანით ხელშეკრულებაში',
        },
        { id: 3, body: 'ყურადღება გაამახვილეთ იმ სერვისებზე რომელზეც ვრცელდება მოცდის პერიოდი' },
        {
          id: 4,
          body: 'მოცდის პერიოდი - ის პერიოდი რომლის განმავლობაშიც კონკრეტული სამედიცინო მომსახურების ხარჯები დროებით არ ანაზღაურდება',
        },
        {
          id: 5,
          body: 'ექიმთან ვიზიტის დასაჯავშნად ან სატელეფონო კონსულტაციის მისაღებად დაუკავშირდით იმედი L-ის ცხელ ხაზს ნომერზე: 0322 92 22 22',
        },
        {
          id: 6,
          body: 'ოჯახის ექიმი მოგისმენთ და უზრუნველყოფს საჭირო კვლევებისა და მიმართვების გამოწერას პროვაიდერ კლინიკებში წარსადგენად',
        },
        {
          id: 7,
          body: 'პროვაიდერ კლინიკაში მიმართვისას ადგილზე იხდით მხოლოდ პოლისით გათვალისწინებულ თქვენს წილ თანხას (ასეთის არსებობის შემთხვევაში)',
        },
        {
          id: 8,
          body: 'პირადი ექიმის მიერ დანიშნული მედიკამენტების შეძენა პროვაიდერ სააფთიაქო ქსელებში შეგიძლიათ თანადაფინანსებით, პოლისისა და პირადობის მოწმობის წარდგენის საფუძველზე',
        },
      ],
    },
  }
  //
  const healthRisks = fakeData.healthRisks
  //
  const stepName = fakeData.translations[lang].stepName
  //
  const isHealthOfferLoading = false
  //
  const mainLoading = isHealthOfferLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('theBestOfferForYou')} />

        <HealthProgressbar stepName={stepName} />

        <Schedule>
          <span
            style={{
              color: filter.paymentSchedule?.id === 1 ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('monthly')}
          </span>
          <ToggleSwitcherStyle
            activeRedBackground={true}
            defaultValue={filter.paymentSchedule?.type === 'MONTHLY' ? false : true}
            onChange={(value) => {
              if (value === true) {
                return [
                  dispatch(
                    setPaymentScheduleArr({
                      id: 1,
                      type: 'ONE-TIME',
                    }),
                  ),
                ]
              } else {
                return [
                  dispatch(
                    setPaymentScheduleArr({
                      id: 2,
                      type: 'MONTHLY',
                    }),
                  ),
                ]
              }
            }}
          />
          <span
            style={{
              color: filter.paymentSchedule?.id === 2 ? Colors.nevadaGrey : Colors.primaryBlack,
            }}
          >
            {t('annual')}
          </span>
        </Schedule>

        {scrollPosition >= 340 && (
          <MovingPrice
            price={
              filter.paymentSchedule?.type === 'MONTHLY'
                ? MainOffer?.calculatedPrices.monthly
                : MainOffer?.calculatedPrices.annual
            }
          />
        )}
        <Price>
          <LeftThreeDot />
          <div>
            {filter.paymentSchedule?.type === 'MONTHLY'
              ? `${MainOffer?.calculatedPrices.monthly} ₾`
              : `${MainOffer?.calculatedPrices.annual} ₾`}
          </div>
          <RightThreeDot />
        </Price>

        <Block>
          {lang === 'ge' ? (
            <OfferTitle>
              იხილეთ <b>{`${MainOffer?.brandName?.[lang]?.title} დაზღვევის`}</b> - ს შეთავაზება
            </OfferTitle>
          ) : (
            <OfferTitle>
              We have found offer from <b>{`${MainOffer?.brandName?.[lang]?.title} insurance`}</b>
            </OfferTitle>
          )}
          <OfferDescription>{t('youCanChooseOtherCompany')}</OfferDescription>
          <CompanySelect
            closeMenuOnSelect={true}
            title={t('changeCompany')}
            onChange={(data) => {
              if (data.value) {
                return [dispatch(setOffer(filter.companyOffers?.find((x) => x.companyId === data.value)))]
              }
            }}
            isMulti={false}
            maxSelectLenght={3}
            maxSelectText={`${t('companyCmpare')}`}
            placeholder={t('selectCompanies')}
            value={MainOffer?.companyId}
            showInnerPrice={true}
            showOptionCheckmark={true}
            options={filter.companyOffers?.map((item) => ({
              value: item.companyId,
              label: item.brandName?.[lang]?.title,
              imgUrl: item.companyLogo,
              price: item.calculatedPrices.monthly,
            }))}
          />
          <br />

          <GetBetterOffer
            defaultValue={false}
            onChange={(value) => {
              // alert('function')
            }}
            title={t('getBetterOffer')}
            description={t('freeChoice')}
          />

          <br />
          <DescriptionBlock>
            <UTitle>
              <li>{t('service')}</li>
              <li>{t('healthLimit')}</li>
              <li>{t('coPayment')}</li>
            </UTitle>
            <Ul>
              <li>{t('ambulatory')}</li>
              <li>{MainOffer?.packageServices?.ambulatory?.limit} %</li>
              <li>{MainOffer?.packageServices?.ambulatory?.payment} ₾</li>
            </Ul>
            <Ul>
              <li>{t('medicines')}</li>
              <li>{MainOffer?.packageServices?.medicines?.limit} %</li>
              <li>{MainOffer?.packageServices?.medicines?.payment} ₾</li>
            </Ul>
            <Ul>
              <li>{t('hospitilazition')}</li>
              <li>{MainOffer?.packageServices?.hospitalization?.limit} %</li>
              <li>{MainOffer?.packageServices?.hospitalization.payment} ₾</li>
            </Ul>
            <Ul>
              <li>{t('dentistry')}</li>
              <li>{MainOffer?.packageServices?.dentistry?.limit} %</li>
              <li>{MainOffer?.packageServices?.dentistry?.payment} ₾</li>
            </Ul>
          </DescriptionBlock>

          <HR />

          <ServicesBlock>
            <TitleBlock>
              <ServicesTitle>{t('service')}</ServicesTitle>
              <ServicesTitle>{t('waitingPeriod')}</ServicesTitle>
            </TitleBlock>

            <TextDiv>
              <LeftText>{t('plannedHospitalization')}</LeftText>
              <RightText>{MainOffer?.services.hospitalization.waitingPeriod + ' ' + t('month')}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('pregnancy/Childbirth')}</LeftText>
              <RightText>{MainOffer?.services.pregnancy.waitingPeriod + ' ' + t('month')}</RightText>
            </TextDiv>

            {MainOffer?.services?.medicines.covered === true && (
              <TextDiv>
                <LeftText>{t('medicinesForIllness')}</LeftText>
                <RightText>{MainOffer.services.medicines.waitingPeriod + ' ' + t('month')}</RightText>
              </TextDiv>
            )}

            <WarningMessage
              variant="gray"
              text="პერიოდი, რომლის განმავლობაშიც დაზღვეულს არ აუნაზღაურდება კონკრეტული სამედიცინო მომსახურების ხარჯები და
              რომელიც აითვლება დაზღვეულის პირველადი დაზღვევის თარიღიდან"
            ></WarningMessage>
          </ServicesBlock>

          <HR />
          <ServicesBlock>
            <ServicesTitle>{t('service')}</ServicesTitle>

            <TextDiv>
              <LeftText>{t('plannedHospitalization')}</LeftText>
              <RightText>
                {MainOffer?.services?.hospitalization.covered === true ? <GreenTick /> : <RedCross />}
              </RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('dayHospitalization')}</LeftText>
              <RightText>
                {MainOffer?.services?.dayHospitalization.covered === true ? <GreenTick /> : <RedCross />}
              </RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('pregnancy/Childbirth')}</LeftText>
              <RightText>{MainOffer?.services?.pregnancy.covered === true ? <GreenTick /> : <RedCross />}</RightText>
            </TextDiv>
          </ServicesBlock>

          <HR />

          <ServicesBlock>
            <TextDiv>
              <LeftText>{t('policyDuration')}</LeftText>
              <RightText>{`12 ` + t('month')}</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('startDate')}</LeftText>
              <RightText>{filter.dates?.start ? dayjs(filter.dates?.start).format('DD MMMM YYYY') : ''}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('endDate')}</LeftText>
              <RightText>{filter.dates?.end ? dayjs(filter.dates?.end).format('DD MMMM YYYY') : ''}</RightText>
            </TextDiv>

            <TextDiv>
              <LeftText>{t('insuredPersonsNumber')}</LeftText>
              <RightText>3</RightText>
            </TextDiv>
          </ServicesBlock>

          <HR />

          <ServicesBlock>
            <TextDiv>
              <LeftText>{t('paymentSchedule')}</LeftText>
              <RightText>
                {filter.paymentSchedule?.type === 'MONTHLY' ? `${t('monthly')}` : `${t('annualPayment')}`}
              </RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('currentPayment')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices.monthly} ₾</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('eachPayment')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices.monthly} ₾</RightText>
            </TextDiv>
            <TextDiv>
              <LeftText>{t('totalAmount')}</LeftText>
              <RightText>{MainOffer?.calculatedPrices.annual} ₾</RightText>
            </TextDiv>
          </ServicesBlock>

          <HR />
          <PriceWrapper>
            <PriceText>
              {filter.paymentSchedule?.type === 'MONTHLY'
                ? `${MainOffer?.calculatedPrices.monthly} ₾/${t('month')}`
                : `${MainOffer?.calculatedPrices.annual} ₾`}
            </PriceText>
            <ATagStyle href={MainOffer?.productWording} target="_blank">
              <div>{t('policyTerms')}</div>
            </ATagStyle>
          </PriceWrapper>
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => {
              if (filter.chooseMethod === 'frani-choice') {
                navigate('/health-choose-method')
              } else if (filter.chooseMethod === 'my-choice') {
                navigate('/health-offers')
              } else {
                navigate('/health-choose-method')
              }
            }}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => navigate('/health-who-do-you-insure')}
          />
        </Buttons>
      </Content>

      <Container>
        <CoveredWrapper>
          <CoveredTitle>{t('whatIsCovered')}</CoveredTitle>
          <CoveredContent>
            {healthRisks.map((item, index) => (
              <CoveredBlock key={index}>
                <CoveredImage src={`${item.icon}`} alt={`${item.riskName}`} />
                <CoveredName>{item?.translations[lang].title}</CoveredName>
                {/* @ts-ignore */}
                <CoveredDescription>{item.riskDescription}</CoveredDescription>

                <CustomLink
                  // @ts-ignore
                  onClick={() => setSelectedCoverageId(item.healthRisKId)}
                  text={t('inDetails')}
                  rightLineIcon={false}
                />

                <VerticalBorder />
              </CoveredBlock>
            ))}
          </CoveredContent>
        </CoveredWrapper>

        <HR />

        <MessageBox>
          <MessageContent>
            <MessageHead>
              <span>{t('notCovered')}</span>
            </MessageHead>
            {MainOffer?.companySlug &&
              // @ts-ignore
              fakeData?.covered?.[MainOffer?.companySlug]?.map((item: any) => (
                <MessageText>
                  <DoubleRightIcon /> <span>{item.body}</span>
                </MessageText>
              ))}
          </MessageContent>
        </MessageBox>
      </Container>

      <BaseModal
        isOpen={healthRisks.find((x) => x.healthRisKId === selectedCoverageId) ? true : false}
        onClose={() => setSelectedCoverageId(0)}
      >
        {healthRisks.find((x) => x.healthRisKId === selectedCoverageId)?.riskDescription}
      </BaseModal>

      {scrollPosition <= 0 && (
        <>
          <BackgroundIcon />
        </>
      )}
    </Wrapper>
  )
}

const DescriptionBlock = styled.div`
  width: 100%;
`
const Ul = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: 60% 20% 18%;
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 13px;
  align-items: center;
  li {
    text-align: right;
    :first-child {
      text-align: left;
    }
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 29% 29%;
  }
`
const UTitle = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: 60% 20% 18%;
  gap: 5px;
  list-style: none;
  padding-left: unset;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;

  li {
    text-align: right;
    :first-child {
      text-align: left;
    }
  }
  ${Responsive.mobile} {
    grid-template-columns: 40% 29% 29%;
  }
`
const ServicesBlock = styled.div`
  display: flex;
  flex-direction: column;
`

const TitleBlock = styled.div`
  display: flex;
  justify-content: space-between;
`
const ServicesTitle = styled.h6`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 20px;
`
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const RightText = styled.div`
  text-align: right;
`
const LeftText = styled.div`
  width: 70%;
`

const PriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`

const MessageText = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  /*  */
  &:last-child {
    margin-bottom: 0px;
  }

  /* message text span */
  span {
    margin-left: 15px;
    color: ${Colors.primaryGrey};
  }

  /* message checkmark icon & svg */
  svg {
    min-width: 20px;
    width: 20px;
    height: 20px;
    margin-left: -3px;
    color: ${Colors.primaryGrey};
  }

  /*  */
  ${Responsive.mobile} {
    /* message checkmark icon & svg */
    svg {
      margin-left: 0px;
      min-width: 15px;
      width: 15px;
    }

    /* message text span */
    span {
      margin-left: 20px;
      color: ${Colors.primaryGrey};
      line-height: 20px;
    }
  }
`
const MessageHead = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  ${Responsive.mobile} {
    font-size: 14px;
    margin-bottom: 15px;

    /* message text span */
    span {
      margin-left: 15px;
    }
  }
`
const MessageContent = styled.div`
  margin-bottom: 33px;
`
const MessageBox = styled.div`
  :first-child {
    border-top: 1px solid ${Colors.secondaryGrey};
    margin-top: 80px;
  }
  padding-top: 30px;
  ${Responsive.tablet} {
    max-width: 700px;
    margin: 0 auto;
  }
`
const Schedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px;

  span {
    font-size: 18px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
    :first-child {
      padding-right: 10px;
    }
    :last-child {
      padding-left: 10px;
    }
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const ToggleSwitcherStyle = styled(ToggleSwitcher)`
  label {
    margin-left: 20px;
  }
`
const CoveredDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryGrey};
  font-weight: normal;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
const CoveredName = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  font-weight: normal;
  margin-bottom: 8px;
  text-align: center;
`
const VerticalBorder = styled.div`
  background-color: ${Colors.secondaryGrey};
  width: 1px;
  height: 100%;
  position: absolute;
  left: -50px;
  display: none;
  ${Responsive.mobile} {
    display: block;
    transform: rotate(0deg);
    width: 100%;
    height: 1px;
    left: 0px;
    top: -13%;
  }
`
const CoveredImage = styled.img`
  min-height: 40px;
  height: 40px;
  width: 48px;
  margin-bottom: 18px;
`
const CoveredTitle = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 60px;
  ${Responsive.mobile} {
    font-size: 18px;
  }
`
const CoveredBlock = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  a {
    span {
      text-decoration: underline;
    }
  }

  &:first-child {
    ${VerticalBorder} {
      display: none;
    }
  }

  ${Responsive.desktop} {
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  /* responsive */
  ${Responsive.laptop} {
    width: 300px;
    &:nth-child(3n) {
      ${VerticalBorder} {
        display: block;
      }
    }
    &:nth-child(3n - 1) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.tablet} {
    width: 300px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
  ${Responsive.mobile} {
    width: 320px;
    /*  */
    &:nth-child(2n) {
      ${VerticalBorder} {
        display: block;
      }
    }
  }
`
const CoveredContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 100px;
  ${Responsive.mobile} {
    gap: 48px;
    justify-content: space-around;
    flex-direction: column;
  }
`

const CoveredWrapper = styled.div`
  margin-block: 80px;
  ${Responsive.mobile} {
    margin-bottom: 40px;
    margin-top: 50px;
  }
`

const PriceText = styled.div`
  font-size: 28px;
  color: ${Colors.primaryBlack};
  text-decoration: none;
  font-weight: bold;

  ${Responsive.mobile} {
    font-size: 24px;
  }
`
const ATagStyle = styled.a`
  font-size: 14px;
  line-height: 18px;
  color: ${Colors.primaryBlack};
  text-align: right;
  font-weight: 500;
  padding-inline: 2px;
  text-decoration: underline;

  &:hover {
    color: ${Colors.primaryBlack};
  }
`

const HR = styled.hr`
  margin-block: 24px;
`

const OfferDescription = styled.h6`
  font-size: 14px;
  margin-bottom: 30px;
  color: ${Colors.nevadaGrey};
`
const OfferTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    font-size: 14px;
  }
`

const Price = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
  user-select: none;
  pointer-events: none;

  /* text */
  div {
    height: 64px;
    background-color: ${Colors.primaryRed};
    border-radius: 40px;
    color: ${Colors.white};
    font-size: 20px;
    padding-inline: 40px;
    margin-inline: 10px;
    display: grid;
    place-items: center;
    box-shadow: 0 4px 35px 0 rgba(254, 95, 85, 0.32);
  }

  svg {
    height: 64px;
  }

  /* Responsive */
  ${Responsive.mobile} {
    div {
      height: 40px;
      font-size: 18px;
      font-weight: bold;
      padding-inline: 23px;
      margin-inline: 0px;
    }

    svg {
      height: 40px;
    }
  }
`
const Block = styled.div`
  max-width: 800px;
  width: 100%;
  padding: 48px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  margin-block: 48px;
  border-radius: 8px;

  ${Responsive.mobile} {
    margin-block: 33px;
    padding: 20px;
    width: calc(100vw - 40px);
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Content = styled.div`
  width: 100%;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  position: relative;
`

//
export default HealthOffer
